<div class="flex w-full items-center justify-between border-b border-gray-200 bg-surface">
  <div id="toolbar" class="w-full !border-none">
    @if(includesFeature('font')) {
      <select class="ql-font">
      </select>
      <select class="ql-header">
      </select>
    }

    @if(includesFeature('font-format')) {
    <span class="ql-formats">
      <button class="ql-bold"></button>
      <button class="ql-italic"></button>
      <button class="ql-underline"></button>
      <button class="ql-strike"></button>
      </span>
    }

    @if(includesFeature('color')) {
      <span class="ql-formats">
        <select class="ql-color"></select>
        <select class="ql-background"></select>
      </span>
    }

    @if(includesFeature('list')) {
      <span class="ql-formats">
        <button class="ql-list" value="ordered"></button>
        <button class="ql-list" value="bullet"></button>
        <select class="ql-align">
        </select>
      </span>
    }

    @if(includesFeature('link') || includesFeature('image')) {
      <span class="ql-formats">
        @if(includesFeature('link')) {
          <button class="ql-link"></button>
        }
        @if(includesFeature('image')) {
          <button class="ql-image"></button>
        }
      </span>
    }

  </div>

  <div class="flex items-center shrink-0 fit-content justify-end">
    <ng-content></ng-content>
  </div>
</div>
<div #quillEditorContainer class="!border-none bg-surface"></div>
